import React, { RefObject, useRef, useState } from "react";
import styled from "styled-components";
import { TabComponent } from "components/ads/Tabs";
import Icon, { IconSize } from "components/ads/Icon";
import DebuggerLogs from "./DebuggerLogs";
import { useDispatch } from "react-redux";
import { showDebugger } from "actions/debuggerActions";
import Errors from "./Errors";
import AnalyticsUtil from "utils/AnalyticsUtil";
import ExecutionLogs from "./ExecutionsLogs";

const TABS_HEADER_HEIGHT = 36;

const Container = styled.div`
  height: 100%;
  width:100%:
  background-color: white;
  ul.react-tabs__tab-list {
    padding: 0px 12px;
  }
  .react-tabs__tab-panel {
    height: calc(100% - 50px);
  }

  .close-debugger {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 12px 15px;
  }
`;

type DebuggerTabsProps = {
  defaultIndex: number;
};

const DEBUGGER_TABS = [
  {
    key: "ERROR",
    title: "Errors",
    panelComponent: <Errors hasShortCut />,
  },
  {
    key: "EXECUTION",
    title: "Execution",
    panelComponent: <ExecutionLogs hasShortCut />,
  },
  {
    key: "LOGS",
    title: "Logs",
    panelComponent: <DebuggerLogs hasShortCut />,
  },
];

function DebuggerTabs(props: DebuggerTabsProps) {
  const [selectedIndex, setSelectedIndex] = useState(props.defaultIndex);
  const dispatch = useDispatch();
  const panelRef: RefObject<HTMLDivElement> = useRef(null);
  const onTabSelect = (index: number) => {
    setSelectedIndex(index);
  };
  const onClose = () => dispatch(showDebugger(false));

  return (
    <Container ref={panelRef}>
      <TabComponent
        onSelect={onTabSelect}
        selectedIndex={selectedIndex}
        tabs={DEBUGGER_TABS}
      />
      <Icon
        className="close-debugger"
        onClick={onClose}
        size={IconSize.SMALL}
      />
    </Container>
  );
}

export default DebuggerTabs;
